import { update } from 'ramda';

// Switch third and fourth indexes in an array
// This is for the canvas where the third "flag" is removed first
export const changeIndexes = array => {
  const third = array[2];
  const fourth = array[3];
  if (third && fourth) {
    let updatedArray = update(3, third, array);
    updatedArray = update(2, fourth, updatedArray);
    return updatedArray;
  } else return array;
};

// Function to ellipsize string based on available width
export const fitStringToWidth = (c, str, maxWidth) => {
  let width = c.measureText(str).width;
  const ellipsis = '…';
  const ellipsisWidth = c.measureText(ellipsis).width;
  if (width <= maxWidth || width <= ellipsisWidth) {
    return str;
  } else {
    let len = str.length;
    while (width >= maxWidth - ellipsisWidth && len-- > 0) {
      str = str.substring(0, len);
      width = c.measureText(str).width;
    }
    return str + ellipsis;
  }
};

export const textTooLongToFit = (text, ctx, maxWidth) => {
  return ctx.measureText(text).width > maxWidth;
};

// From https://fjolt.com/article/html-canvas-how-to-wrap-text
export const wrapText = (ctx, text, x, y, maxWidth, lineHeight) => {
  // First, start by splitting all of our text into words, but splitting it into an array split by spaces
  const words = text.split(' ');
  let line = ''; // This will store the text of the current line
  let testLine = ''; // This will store the text when we add a word, to test if it's too long
  let lineArray = []; // This is an array of lines, which the function will return

  // Lets iterate over each word
  for (var n = 0; n < words.length; n++) {
    // Create a test line, and measure it..
    testLine += `${words[n]} `;
    let metrics = ctx.measureText(testLine);
    let testWidth = metrics.width;
    // If the width of this test line is more than the max width
    if (testWidth > maxWidth && n > 0) {
      // Get offset X for centering text
      const lineWidth = ctx.measureText(line).width;
      const offset = lineWidth < maxWidth ? (maxWidth - lineWidth) / 2 : 0;
      // Then the line is finished, push the current line into "lineArray"
      lineArray.push([line, x + offset, y]);
      // Increase the line height, so a new line is started
      y += lineHeight;
      // Update line and test line to use this word as the first word on the next line
      line = `${words[n]} `;
      testLine = `${words[n]} `;
    } else {
      // If the test line is still less than the max width, then add the word to the current line
      line += `${words[n]} `;
    }
    // If we never reach the full max width, then there is only one line..
    // so push it into the lineArray so we return something
    if (n === words.length - 1) {
      // Get offset X for centering text
      const lineWidth = ctx.measureText(line).width;
      const offset = (maxWidth - lineWidth) / 2;
      lineArray.push([line, x + offset, y]);
    }
  }
  // Return the line array
  return lineArray;
};
